/* Product page: split the product body into the right places.
   - 尺寸表  -> Size Chart accordion (table if there is one, otherwise the sentence)
   - 購買須知 -> notes block under the three accordions
   - everything else stays in Description
   Works whatever the body markup is (flat headings, wrapped sections, <strong> headings...).
   If the target containers are missing, nothing is moved. */
(function () {
  'use strict';

  var SIZE = ['尺寸表', '尺碼表', '尺码表', 'sizechart'];
  var NOTES = ['購買須知', '購物須知', '購物需知', '购买须知', '购物须知', '購買需知'];
  var OTHER = ['商品資料', '商品資訊', '商品详情', '商品信息', '商品說明', '商品描述'];

  function norm(t) { return (t || '').replace(/[\s\u00a0:：]/g, '').toLowerCase(); }
  function kindOf(t) {
    t = norm(t);
    if (SIZE.indexOf(t) > -1) return 'size';
    if (NOTES.indexOf(t) > -1) return 'notes';
    if (OTHER.indexOf(t) > -1) return 'other';
    return null;
  }
  function isHeadTag(el) { return /^H[1-6]$/.test(el.tagName); }

  // deepest elements whose whole text is a known heading
  function findHeadings(root) {
    var out = [];
    root.querySelectorAll('*').forEach(function (el) {
      if (/^(SCRIPT|STYLE|TD|TH|TR|TABLE|LI|UL|OL)$/.test(el.tagName)) return;
      var k = kindOf(el.textContent);
      if (!k) return;
      var deeper = Array.prototype.some.call(el.children, function (c) { return kindOf(c.textContent) === k; });
      if (deeper) return;
      // climb while the parent holds nothing but this heading
      var node = el;
      while (node.parentElement && node.parentElement !== root && norm(node.parentElement.textContent) === norm(el.textContent)) {
        node = node.parentElement;
      }
      out.push({ kind: k, node: node });
    });
    return out;
  }

  function startsSection(el) {
    if (isHeadTag(el)) return true;
    if (kindOf(el.textContent)) return true;
    var f = el.firstElementChild;
    return !!(f && (isHeadTag(f) || kindOf(f.textContent)));
  }

  function sectionNodes(head) {
    var nodes = [head], sib = head.nextElementSibling;
    while (sib && !startsSection(sib)) { nodes.push(sib); sib = sib.nextElementSibling; }
    return nodes;
  }

  function pruneEmpty(el, root) {
    var p = el;
    while (p && p !== root && !p.textContent.trim() && !p.querySelector('img,table,video,iframe')) {
      var up = p.parentElement; p.remove(); p = up;
    }
  }

  function run() {
    var desc = document.querySelector('[data-ts-role="description"]');
    if (!desc || desc.getAttribute('data-ts-done')) return;
    var sizeBox = document.querySelector('[data-ts-role="size"]');
    var notesBox = document.querySelector('[data-ts-role="notes"]');

    var heads = findHeadings(desc);

    heads.filter(function (h) { return h.kind === 'size'; }).forEach(function (h) {
      if (!sizeBox) return;
      var nodes = sectionNodes(h.node);
      var content = nodes.slice(1);
      var table = null;
      content.forEach(function (el) { if (!table) table = el.tagName === 'TABLE' ? el : el.querySelector('table'); });
      if (table && !sizeBox.querySelector('table')) {
        sizeBox.innerHTML = '';
        var wrap = document.createElement('div');
        wrap.className = 'size-chart-wrap';
        wrap.appendChild(table.cloneNode(true));
        sizeBox.appendChild(wrap);
      } else if (!table) {
        var fb = sizeBox.querySelector('.size-chart-fallback');
        var text = content.map(function (el) { return (el.textContent || '').trim(); }).join(' ').trim();
        if (fb && text) fb.textContent = text;
      }
      var parent = h.node.parentElement;
      nodes.forEach(function (n) { n.remove(); });
      pruneEmpty(parent, desc);
    });

    heads.filter(function (h) { return h.kind === 'notes'; }).forEach(function (h) {
      if (!notesBox) return;
      var nodes = sectionNodes(h.node);
      var parent = h.node.parentElement;
      nodes.forEach(function (n) { notesBox.appendChild(n); });
      pruneEmpty(parent, desc);
    });

    // wording fix: pre-order delivery time shown in the shopping notes
    var PREORDER_TEXT = '預訂商品大約14個工作天內到貨';
    [notesBox, desc].forEach(function (box) {
      if (!box) return;
      box.querySelectorAll('li, p').forEach(function (el) {
        var t = el.textContent || '';
        if (t.indexOf('預訂商品') > -1 && t.indexOf('到貨') > -1 && t.length < 60 && !el.querySelector('li, p')) {
          el.textContent = PREORDER_TEXT;
        }
      });
    });

    desc.setAttribute('data-ts-done', '1');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  // COLOR: BLACK / SIZE: M  -> update the shown value as soon as an option is clicked
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var fs = t.closest ? t.closest('fieldset.product-form__input') : null;
    var span = fs && fs.querySelector('[data-selected-value]');
    if (span) span.textContent = t.value + (t.getAttribute('data-last-one') ? ' (Last 1)' : '');
  });
})();
